import { ImportFunnelTemplateModal } from "./import-template-container";

export default ImportFunnelTemplateModal;